import { Extension } from "@tiptap/core";

/**
 * Backspace in an empty bullet point leaves the list instead of pulling the
 * cursor back into the point above it. That is how a list is ended everywhere
 * else: press enter for one more point, and backspace once it turns out none is
 * needed.
 *
 * The list keymap of tiptap does the opposite as long as there is a point
 * above, which leaves no way of writing plain text underneath a list. Its
 * behaviour is kept for a point which still says something, since joining that
 * one onto the point above is what backspace is for.
 *
 * The priority is what puts this ahead of that keymap; without it the two would
 * be decided by the order they happen to be registered in.
 */
const LeaveListOnBackspace = Extension.create({
    name: "leaveListOnBackspace",
    priority: 1000,

    addKeyboardShortcuts() {
        return {
            Backspace: ({ editor }) => {
                const { selection } = editor.state;

                if (!selection.empty || !editor.isActive("listItem")) {
                    return false;
                }

                if (selection.$from.parent.content.size > 0) {
                    return false;
                }

                return editor.commands.liftListItem("listItem");
            },
        };
    },
});

export { LeaveListOnBackspace };
